<template>
  <div>
    <amount-actually-paid type="on_pay" />
    <page-header :title="$t('scope.text_266')" :tabs="options" :current-tab.sync="currentType" />
    <page-body>
      <pending-payment-list :id="listId" :getParams="getParams" :cloud-env="currentType" />
    </page-body>
  </div>
</template>

<script>
import AmountActuallyPaid from '../../sections/AmountActuallyPaid'
import PendingPaymentList from './components/List'

export default {
  name: 'pendingPaymentIndex',
  components: {
    PendingPaymentList,
    AmountActuallyPaid,
  },
  data () {
    return {
      listId: 'pendingPaymentList',
      getParams: {
        details: true,
      },
      options: [
        { key: 'on_pay', label: this.$t('scope.text_515') },
        { key: 'paid', label: this.$t('scope.text_437') },
        { key: 'expire', label: this.$t('scope.text_832') },
        { key: 'cancel', label: this.$t('scope.text_833') },
      ],
      currentType: 'on_pay',
    }
  },
}
</script>
